import React from "react";
import {
  WSFlexBox,
  WSIcon,
  WSList,
  WSPanel,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { WSQueries } from "../../../../../../query/WSQuery";
import { useBackgroundChecksSettingsQuery } from "../../../../../../query/backgroundChecks/queries/useBackgroundChecksSettingsQuery";
import { EmptyComponent } from "../../../../../../shared/components/EmptyComponent";
import { IBackgroundCheckPackageSearch } from "@wingspanhq/background-checks/dist/lib/interfaces/backgroundCheckPackage";

const ListItem: React.FC<{ label: string }> = ({ label }) => {
  return (
    <WSFlexBox.CenterY wrap="nowrap" alignItems="flex-start">
      <WSIcon name="shield-check" color="gray500" size="S" mr="M" />
      <WSText.ParagraphSm>{label}</WSText.ParagraphSm>
    </WSFlexBox.CenterY>
  );
};

export const ReportsInfoWidgetContent: React.FC<{
  searches?: IBackgroundCheckPackageSearch[];
}> = ({ searches }) => {
  return searches ? (
    <WSList gap="S">
      <WSSectionToolbar title="Reports" />
      <WSPanel>
        <WSList gap="M">
          {searches.map(({ title, group, type }, index) => (
            <ListItem key={title + index} label={title} />
          ))}
        </WSList>
      </WSPanel>
    </WSList>
  ) : null;
};

export const ReportsInfoWidget: React.FC<{
  backgroundCheckRequestSettingsId: string;
}> = ({ backgroundCheckRequestSettingsId }) => {
  const queryBackgroundCheckRequestSettings = useBackgroundChecksSettingsQuery(
    backgroundCheckRequestSettingsId
  );

  return (
    <WSQueries
      queries={{ queryBackgroundCheckRequestSettings }}
      renderErrors={EmptyComponent}
      renderLoader={EmptyComponent}
    >
      {({ queryBackgroundCheckRequestSettingsData }) => {
        return (
          <ReportsInfoWidgetContent
            searches={queryBackgroundCheckRequestSettingsData.package?.searches}
          />
        );
      }}
    </WSQueries>
  );
};
